/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { editorCreatePublication } from '../fn/editor-publications-controller/editor-create-publication';
import { EditorCreatePublication$Params } from '../fn/editor-publications-controller/editor-create-publication';
import { editorDeletePublication } from '../fn/editor-publications-controller/editor-delete-publication';
import { EditorDeletePublication$Params } from '../fn/editor-publications-controller/editor-delete-publication';
import { editorGetPublication } from '../fn/editor-publications-controller/editor-get-publication';
import { EditorGetPublication$Params } from '../fn/editor-publications-controller/editor-get-publication';
import { editorGetPublications } from '../fn/editor-publications-controller/editor-get-publications';
import { EditorGetPublications$Params } from '../fn/editor-publications-controller/editor-get-publications';
import { editorUpdatePublication } from '../fn/editor-publications-controller/editor-update-publication';
import { EditorUpdatePublication$Params } from '../fn/editor-publications-controller/editor-update-publication';
import { Publication } from '../models/publication';
import { PublicationWithRelations } from '../models/publication-with-relations';

@Injectable({ providedIn: 'root' })
export class EditorPublicationsControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `publicationControllerEditorGetPublication()` */
  static readonly PublicationControllerEditorGetPublicationPath = '/editor/publications/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `editorGetPublication()` instead.
   *
   * This method doesn't expect any request body.
   */
  editorGetPublication$Response(params: EditorGetPublication$Params, context?: HttpContext): Observable<StrictHttpResponse<PublicationWithRelations>> {
    return editorGetPublication(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `editorGetPublication$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  editorGetPublication(params: EditorGetPublication$Params, context?: HttpContext): Observable<PublicationWithRelations> {
    return this.editorGetPublication$Response(params, context).pipe(
      map((r: StrictHttpResponse<PublicationWithRelations>): PublicationWithRelations => r.body)
    );
  }

  /** Path part for operation `publicationControllerEditorUpdatePublication()` */
  static readonly PublicationControllerEditorUpdatePublicationPath = '/editor/publications/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `editorUpdatePublication()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  editorUpdatePublication$Response(params: EditorUpdatePublication$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return editorUpdatePublication(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `editorUpdatePublication$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  editorUpdatePublication(params: EditorUpdatePublication$Params, context?: HttpContext): Observable<any> {
    return this.editorUpdatePublication$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `publicationControllerEditorGetPublications()` */
  static readonly PublicationControllerEditorGetPublicationsPath = '/editor/publications';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `editorGetPublications()` instead.
   *
   * This method doesn't expect any request body.
   */
  editorGetPublications$Response(params?: EditorGetPublications$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PublicationWithRelations>>> {
    return editorGetPublications(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `editorGetPublications$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  editorGetPublications(params?: EditorGetPublications$Params, context?: HttpContext): Observable<Array<PublicationWithRelations>> {
    return this.editorGetPublications$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PublicationWithRelations>>): Array<PublicationWithRelations> => r.body)
    );
  }

  /** Path part for operation `publicationControllerEditorCreatePublication()` */
  static readonly PublicationControllerEditorCreatePublicationPath = '/editor/publications';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `editorCreatePublication()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  editorCreatePublication$Response(params?: EditorCreatePublication$Params, context?: HttpContext): Observable<StrictHttpResponse<Publication>> {
    return editorCreatePublication(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `editorCreatePublication$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  editorCreatePublication(params?: EditorCreatePublication$Params, context?: HttpContext): Observable<Publication> {
    return this.editorCreatePublication$Response(params, context).pipe(
      map((r: StrictHttpResponse<Publication>): Publication => r.body)
    );
  }

  /** Path part for operation `publicationControllerEditorDeletePublication()` */
  static readonly PublicationControllerEditorDeletePublicationPath = '/editor/publications';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `editorDeletePublication()` instead.
   *
   * This method doesn't expect any request body.
   */
  editorDeletePublication$Response(params: EditorDeletePublication$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return editorDeletePublication(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `editorDeletePublication$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  editorDeletePublication(params: EditorDeletePublication$Params, context?: HttpContext): Observable<any> {
    return this.editorDeletePublication$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

}
